export default __webpack_public_path__ + "static/media/boat-top.0dc30a56.svg";